import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';

export default function AboutPage() {
  useEffect(() => {
    document.title = 'About ChronoTech Robotics';

    const desiredDescription =
      'ChronoTech Robotics brings engineering and coding into every home with playful kits and live classes. Based in Silicon Valley, we build small personal robots and soft robotic muscles.';

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', desiredDescription);
  }, []);

  return (
    <main className="aboutContainer">
      <h1>About ChronoTech Robotics</h1>

      <section className="aboutGrid">
        {/* Left: concept image */}
        <figure className="aboutHero">
          <img
            src="/images/aboutpic.jpg"
            alt="AI robot concept illustration"
            width="1200"
            height="900"
            loading="lazy"
            sizes="(max-width: 768px) 100vw, 480px"
          />
          <figcaption className="visuallyHidden">
            Concept art representing accessible robotics
          </figcaption>
        </figure>

        {/* Right: mission + story */}
        <div className="aboutText">
          <p>
            ChronoTech Robotics is on a mission to bring engineering, coding, and
            robotics into every home starting with our latest model, the Robo Chef. Based in
            Silicon Valley, we’re developing small-scale personal robots and
            electromagnetic devices.
          </p>
          <p>
            Our Robo Kids Learning program delivers live Zoom-based robotics
            classes with real kits shipped to students across the U.S. Every
            experience is crafted to teach hands-on skills in electronics, coding,
            and design thinking—in a way that is fun and inspiring for kids of all
            backgrounds.
          </p>
          <p>
            Whether you're a parent, teacher, or enthusiast—we're here to spark
            the imagination of the next generation of inventors.
          </p>

          {/* Bio cards styled like shop cards */}
          <div className="aboutBioCards">
            <Link className="bioCard" to="/about/founder-mohit-singh">
              <img
                src="/images/mohit.png"
                alt="Founder — Mohit Singh"
                width="96"
                height="96"
                loading="lazy"
              />
              <div className="bioInfo">
                <h3>Founder — Mohit Singh</h3>
                <p>Vision, product, and robotics R&amp;D.</p>
              </div>
            </Link>

            <Link className="bioCard" to="/about/director-kaitlyn-lowery">
              <img
                src="/images/kaitlyn.png"
                alt="Director of Educational Services — Kaitlyn Lowery"
                width="96"
                height="96"
                loading="lazy"
              />
              <div className="bioInfo">
                <h3>Director of Educational Services — Kaitlyn Lowery</h3>
                <p>Curriculum design and classroom excellence.</p>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
